<template>
     <div class="history-filters">   
        <!-- DATE FROM/TILL START  -->
        <div class="history-filter">
            <el-date-picker 
                type="date" 
                placeholder="Pick a date"
                v-model="form.date_from" 
                style="width: 100%;"
                @change="filter"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"  
            ></el-date-picker>
        </div>

        <div class="history-filter">
            <el-date-picker 
                type="date" 
                placeholder="Pick a date"
                v-model="form.date_till" 
                style="width: 100%;"
                @change="filter"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
            ></el-date-picker>
        </div>  
        <!-- DATE FROM/TILL END  -->

        <!-- ORDERS QUANTITY FROM/TO START  -->
        <div class="history-filter">
            <el-input 
                placeholder="Orders quantity (from)" 
                v-model="form.orders_quantity_from"
                clearable
                min="1" 
                @change="filter"
            ></el-input>
        </div>

        <div class="history-filter">
           <el-input 
                placeholder="Orders quantity (till)" 
                v-model="form.orders_quantity_to"
                clearable
                min="1" 
                @change="filter" 
            ></el-input>
        </div>
        <!-- ORDERS QUANTITY FROM/TO END  -->

        <!-- MASTERS QUANTITY FROM/TO START  -->
        <div class="history-filter">
            <el-input 
                placeholder="Masters quantity (from)"
                v-model="form.master_quantity_from"
                clearable
                min="1"  
                @change="filter"
            ></el-input>
        </div>

        <div class="history-filter">
            <el-input 
                placeholder="Masters quantity (till)" 
                v-model="form.master_quantity_to"
                clearable
                min="1"  
                @change="filter"
            ></el-input>
        </div>
        <!-- MASTERS QUANTITY FROM/TO END  -->

        <!-- SOLD HOURS FROM/TO START  -->
        <div class="history-filter">
            <el-input 
                placeholder="Sold hours (from)" 
                v-model="form.indicator_1_from"
                clearable
                min="1" 
                max="100"
                @change="filter"
            ></el-input>
        </div>

        <div class="history-filter">
            <el-input 
                placeholder="Sold hours (till)" 
                v-model="form.indicator_1_to"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>
        <!-- SOLD HOURS FROM/TO END  -->

        <!-- DENIED FROM/TO START  -->
        <div class="history-filter">
            <el-input 
                placeholder="Denied (from)"
                v-model="form.indicator_2_from"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>

        <div class="history-filter">
           <el-input 
                placeholder="Denied (till)"
                v-model="form.indicator_2_to"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>
        <!-- DENIED FROM/TO END -->

        <!-- CARRY OVER FROM/TO START  -->
        <div class="history-filter">
            <el-input 
                placeholder="Carry over (from)"
                v-model="form.indicator_3_from"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>

        <div class="history-filter">
            <el-input 
                placeholder="Carry over (till)"  
                v-model="form.indicator_3_to"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>
        <!-- CARRY OVER FROM/TO END  -->

        <!-- CANCELED FROM/TO START  -->
        <div class="history-filter"> 
            <el-input 
                placeholder="Canceled (from)" 
                v-model="form.indicator_4_from"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>

        <div class="history-filter">
            <el-input 
                placeholder="Canceled (till)" 
                v-model="form.indicator_4_to"
                clearable
                min="1"
                max="100"
                @change="filter"
            ></el-input>
        </div>
        <!-- CANCELED FROM/TO END  -->

        <!-- LATENESS FROM/TO START  -->
        <div class="history-filter">
            <el-input 
                placeholder="Lateness (from)"  
                v-model="form.lateness_from" 
                clearable
                min="1"
                max="100"
            ></el-input>
        </div>

        <div class="history-filter">
            <el-input 
                placeholder="Lateness (till)"  
                v-model="form.lateness_till"
                clearable
                min="1"
                max="100"
            ></el-input>
        </div>
        <!-- LATENESS FROM/TO END  -->
        <!-- <div class="history-filter">
            <button class="clear">clear</button>
        </div> -->
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    name: 'history-filters',
    data() {
        return {
            services: [
                {
                    value: 'All',
                    label: 'All'
                },
                {
                    value: 'Service 1',
                    label: 'Service 1'
                },
                {
                    value: 'Service 2',
                    label: 'Service 2'
                },
                {
                    value: 'Service 3',
                    label: 'Service 3'
                }
            ],
            service: '', 
            cof: '',
            cofs: [
                {
                    value: 'All',
                    label: 'All'
                },
                {
                    value: '1.00',
                    label: '1.00'
                },
                {
                    value: '1.50',
                    label: '1.50'
                },
                {
                    value: '1.75',
                    label: '1.75'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            form: 'simulation/params'
        })
    },
    methods: {
        ...mapMutations({
            resetCurrentPage: 'simulation/resetCurrentPage',
        }),
        ...mapActions({
            getFilter: 'simulation/getFilter'
        }),
        filter() {
            this.resetCurrentPage();
            this.getFilter();
        }
    }
}
</script>

<style lang="scss">
.history-filters {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
}

.history-filter {
    margin-right: 35px;
    margin-bottom: 15px;
}

.clear { 
    width: 130px;
    height: 100%;
    background-color: #262538;
    font-weight: 600;
    font-size: 14px;
    border-radius: 4px;
    transition: all .3s ease-out;
    cursor: pointer;
    color: #fff;
    border: none;

    &:hover {
        background-color: #262538d1;
    }
}
</style>

<style>
.history-filter .el-input input {
    max-width: 169px !important;
}
</style>